import BButton from 'components/common/BButton';
import VehicleDetailTitledSection from 'components/Vehicle/VehicleDetail/VehicleDetailTitledSection';
import useTranslation from 'next-translate/useTranslation';
import React, { FunctionComponent, useEffect, useRef, useState } from 'react';
import { cn } from 'utils/cn';

interface ExperienceDetailClampTextSectionProps {
  className?: string;
  description: string;
  title: string;
}

const ExperienceDetailClampTextSection: FunctionComponent<
  ExperienceDetailClampTextSectionProps
> = ({ className, description, title }) => {
  const { t } = useTranslation('vehicle');
  const descriptionRef = useRef<HTMLDivElement>(null);

  const [showFullContent, setShowFullContent] = useState<boolean>(false);
  const [showButton, setShowButton] = useState<boolean>(true);

  useEffect(() => {
    if (
      descriptionRef.current &&
      descriptionRef.current.offsetHeight >= descriptionRef.current.scrollHeight
    ) {
      setShowButton(false);
    }
  }, []);

  return (
    <VehicleDetailTitledSection
      className={cn('whitespace-pre-line', className)}
      title={title}
    >
      <div
        ref={descriptionRef}
        className={cn({
          'clamp-3-line': !showFullContent,
        })}
      >
        {description}
      </div>
      {showButton ? (
        <div>
          <BButton
            priority="none"
            className="mt-2 underline md:hover:no-underline"
            onClick={() => setShowFullContent((fc) => !fc)}
          >
            {showFullContent
              ? t('common:seo.seeLess')
              : t('common:seo.seeMore')}
          </BButton>
        </div>
      ) : null}
    </VehicleDetailTitledSection>
  );
};

export default ExperienceDetailClampTextSection;
